import enviro from 'enviro';
import { useState } from 'react';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { SHORT_IDS_PRACTICE_MODE_PROD, SHORT_IDS_PRACTICE_MODE_QA } from './practiceModeConsts';
const isEnabledForShort = shortId => {
  if (!shortId) return false;
  if (enviro.isQa()) {
    return SHORT_IDS_PRACTICE_MODE_QA.includes(shortId);
  }
  return SHORT_IDS_PRACTICE_MODE_PROD.includes(shortId);
};
export const useIsPracticeModeEnabled = shortId => {
  const [showPracticeModeOverlay, setShowPracticeModeOverlay] = useState(isEnabledForShort(shortId));
  const {
    isNotLaptop
  } = useMediaQuery();
  return {
    isPracticeModeEnabled: isNotLaptop && showPracticeModeOverlay,
    setShowPracticeModeOverlay
  };
};